import { useMemo } from 'react'
import { aOrganization, aUser, useAtomValue } from '~/atoms'
import { UserGroup, type Listing } from '~/models'
import CrsData from './CrsData'
import RprLinks from './RprLinks'

export default function Connections({ listing }: { listing: Listing }) {
  const user = useAtomValue(aUser)
  const organization = useAtomValue(aOrganization)

  const hasCrsDataAccess = useMemo(() => {
    if (!user) return false
    return (
      organization!.options.crsDataEnabled &&
      (user.group !== UserGroup.member || user.options?.hasCrsDataAccess)
    )
  }, [user])

  const showConnections = useMemo(() => {
    if (!user) return false
    const conditions = [!!user!.meta?.nrdsIdNumber, hasCrsDataAccess]
    return conditions.some((condition) => condition)
  }, [user, hasCrsDataAccess])

  if (!showConnections) {
    return null
  }

  return (
    <div>
      <h4 className="mb-4 mt-6 text-xl font-medium">Partnerships</h4>
      <div className="flex gap-4">
        {user?.meta?.nrdsIdNumber && <RprLinks listing={listing} />}
        {hasCrsDataAccess && <CrsData listing={listing} />}
      </div>
    </div>
  )
}
